// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Lock as RawLock } from "lucide-react";
export const Lock = /* @__PURE__ */ createIcon(RawLock, "Lock", 2);
